// forms.js
// Client-side validation feedback for .form — FormIt handles submission server-side.

function getFieldError(field) {
  const group = field.closest('.form__group');
  return group ? group.querySelector('.form__error') : null;
}

function showFieldError(field) {
  field.classList.add('is-invalid');
  field.setAttribute('aria-invalid', 'true');
  const error = getFieldError(field);
  if (error) {
    error.hidden = false;
    if (!error.textContent.trim()) error.textContent = field.validationMessage;
  }
}

function clearFieldError(field) {
  field.classList.remove('is-invalid');
  field.removeAttribute('aria-invalid');
  const error = getFieldError(field);
  if (error) {
    error.hidden = true;
    error.textContent = '';
  }
}

function initForms() {
  const forms = document.querySelectorAll('.form');

  if (!forms.length) return;

  forms.forEach((form) => {
    const fields = form.querySelectorAll('[required]');
    const todayFields = form.querySelectorAll('[data-min-today]');

    todayFields.forEach(field => {
      const now = new Date();
      const localDate = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
        .toISOString()
        .slice(0, 10);
      field.min = localDate;
    });

    fields.forEach((field) => {
      field.addEventListener('input', () => clearFieldError(field));
      field.addEventListener('change', () => clearFieldError(field));
    });

    form.addEventListener('submit', (event) => {
      let isValid = true;

      fields.forEach((field) => {
        if (!field.checkValidity()) {
          showFieldError(field);
          isValid = false;
        } else {
          clearFieldError(field);
        }
      });

      if (!isValid) {
        event.preventDefault();
        event.stopImmediatePropagation();
        form.querySelector('.is-invalid')?.focus();
      }
    }, true);

    if (form.matches('[data-ajax-form]')) {
      form.addEventListener('formit:beforesubmit', () => {
        form.setAttribute('aria-busy', 'true');
      });

      form.addEventListener('formit:complete', () => {
        form.removeAttribute('aria-busy');
      });

      form.addEventListener('formit:success', () => {
        const fields = form.querySelector('[data-form-fields]');
        const success = form.querySelector('[data-form-success-panel]');

        if (fields) fields.hidden = true;
        if (success) {
          success.hidden = false;
          success.focus();
        }

        if (window.location.hash === '#newsletter-signup') {
          window.history.replaceState(null, '', `${window.location.pathname}${window.location.search}`);
        }
      });
    }
  });

  document.querySelector('[data-form-success]')?.focus();
}

export default initForms;
